import { Component, inject } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';

import { ListPlanDevicesComponent } from '../list-plan-devices/list-plan-devices.component';
@Component({
    selector: 'app-plan-devices',
    templateUrl: './plan-devices.component.html',
    styleUrls: ['./plan-devices.component.css'],
    imports: [ListPlanDevicesComponent, CommonModule]
})
export class PlanDevicesComponent {

  public location = inject(Location);

  dataInput: any;

  information: string = '';

  /**
   *
   */
  constructor( private router: Router, private route: ActivatedRoute) {

  }

  ngOnInit() {
    
    this.dataInput = history.state.dataInputPlanDevice;
    this.information = "Customer ID # " + this.dataInput.customerId + " / " + this.dataInput.customerName + " / " + this.dataInput.planID + " / " + this.dataInput.planName;
  }

  goBack() {
    /*
    let customer = {
      userId: this.dataInput.customerId,
    };
    this.router.navigate(['/customers/customer-plans'], {
      relativeTo: this.route,
      state: { customerData: customer },
    });
    */
    this.location.back();
  }
}
